import { Component, OnInit, ViewChild } from '@angular/core';
import { AlteGrundbuchmeldungSearchRequestMeta, GbAlteGrundbuchmeldungService } from '../../../core/gb-api';
import { GbGemeindeSearchMode } from '../../../shared/widgets/gb-gemeinde/gbGemeindeSearchMode';
import { FormsModule, NgForm } from '@angular/forms';
import { simplify } from '../../../shared/functions/meta.functions';
import { ActivatedRoute, Router } from '@angular/router';
import { GrundstueckNummerComponent } from '../../../shared/widgets/grundstueck-nummer/grundstueck-nummer.component';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './alte-grundbuchmeldung-suche.component.html',
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    FormsModule,
    MetaDirective,
    GrundstueckNummerComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class AlteGrundbuchmeldungSucheComponent extends AbstractSearchComponent implements OnInit {
  searchRequest: AlteGrundbuchmeldungSearchRequestMeta;
  searchMode = GbGemeindeSearchMode.ALTE_GRUNDBUCHMELDUNG_REGISTER_SEARCH;
  @ViewChild('form', { static: false })
  form: NgForm;
  @ViewChild(GrundstueckNummerComponent, { static: true })
  private grundstueckNummerComponent: GrundstueckNummerComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private alteGrundbuchmeldungService: GbAlteGrundbuchmeldungService,
    stateService: SearchStateService
  ) {
    super(stateService);
    keysToTranslate(['altegrundbuchmeldung.search.breadcrumb']);
  }

  ngOnInit() {
    this.loadAndApplySearchTemplate();
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }
    this.stateService.lastRequest = this.searchRequest;
    this.markFormAsTouched(this.form);
    this.router.navigate(['list'], {
      relativeTo: this.route,
      queryParams: {
        request: JSON.stringify(simplify(this.searchRequest))
      }
    });
  }

  onReset() {
    this.form.reset();
    this.grundstueckNummerComponent.focus();
    this.addSub(
      this.alteGrundbuchmeldungService.searchTemplateAlteGrundbuchmeldung().subscribe((template) => {
        this.searchRequest = template;
      })
    );
  }

  private loadAndApplySearchTemplate() {
    this.addSub(
      this.alteGrundbuchmeldungService.searchTemplateAlteGrundbuchmeldung().subscribe((template) => {
        if (this.stateService.lastRequest && this.stateService.lastRequest.grundstueckNummerSearchRequest) {
          this.stateService.lastRequest.grundstueckNummerSearchRequest.gbGemeindeId = null;
        }
        this.searchRequest = this.copyLastRequest(template);
        if (!this.searchRequest?.grundstueckNummerSearchRequest?.nummer) {
          this.grundstueckNummerComponent.focus();
        }
      })
    );
  }

  private markFormAsTouched(form: NgForm) {
    for (const control of Object.values(form.controls)) {
      control.markAsTouched();
    }
  }
}
